import fetch from 'isomorphic-fetch';
import * as ActionType from '../types/website/EntityActionTypes';
import { confirmation } from '../NotificationActions';
/* eslint-disable-next-line import/no-cycle */
import { TRAVEL_TYPES } from './entities/TravelActions';

const ENTITY_TYPES = {
  POI: 'Recommendation',
  RSVP: 'Event',
  WEDDING_PARTY: 'Wedding Party Member',
  FAQ: 'FAQ',
  TRAVEL: 'Travel',
  HOME: 'Story',
  PHOTO: 'Photo',
  EVENT: 'Event',
  REGISTRY: 'Registry',
};

export function updateEntityRequest() {
  return {
    type: ActionType.ENTITY_REQUESTED
  };
}

export function receiveEntityResponse(response) {
  return {
    type: ActionType.ENTITY_CREATED,
    payload: { entity: response }
  };
}

export function receiveUpdatedEntityResponse(response) {
  return {
    type: ActionType.ENTITY_RECEIVED,
    payload: { entity: response }
  };
}

export function getEntitiesRequest() {
  return {
    type: ActionType.ENTITIES_REQUESTED
  };
}

export function getEntitiesResponse(response, entityListName) {
  return {
    type: ActionType.ENTITIES_RECEIVED,
    payload: { entities: response[entityListName], mealOptions: response.meal_options }
  };
}

export function editEntityRequest(entity) {
  return {
    type: ActionType.ENTITY_SELECTED,
    payload: { id: entity.id }
  };
}

export function entityDeleted(id) {
  return {
    type: ActionType.ENTITY_DELETED,
    payload: { id }
  };
}

export function entityMoved(response) {
  return {
    type: ActionType.ENTITY_MOVED,
    payload: { entities: response }
  };
}

export function resetEntities() {
  return { type: ActionType.ENTITIES_RESET };
}

export function addEntity() {
  return {
    type: ActionType.ENTITY_ADD
  };
}

export function requestSuggestions() {
  return {
    type: ActionType.SUGGESTIONS_REQUESTED
  };
}

export function receiveSuggestions(data) {
  return {
    type: ActionType.SUGGESTIONS_RECEIVED,
    payload: data
  };
}

export function requestMealOptions() {
  return {
    type: ActionType.MEAL_OPTIONS_REQUESTED
  };
}

export function receiveMealOptions(data) {
  return {
    type: ActionType.MEAL_OPTIONS_RECEIVED,
    payload: data
  };
}

export function reorderEntities() {
  return (dispatch, getState) => {
    const requestBody = {
      entityIds: getState().website.entities.orderedIds,
      pageId: getState().website.pages.activePage.id
    };
    return fetch('/web-api/v1/cms/page/pages/list/reorder',
      {
        credentials: 'same-origin',
        headers: {
          'Content-type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(requestBody)
      })
      .then(response => response.json())
      .then(json => dispatch(entityMoved(json)))
      .catch();
  };
}

export function moveEntity(oldIndex, newIndex) {
  return (dispatch) => {
    dispatch({ type: ActionType.ENTITY_MOVE, payload: { oldIndex, newIndex } });
    dispatch(reorderEntities());
  };
}

export function deleteEntityV2(entity) {
  return (dispatch, getState) => {
    dispatch({ type: ActionType.ENTITY_DELETE, payload: { id: entity.id } });
    const { activePage } = getState().website.pages;
    const requestBody = {
      entityId: entity.id,
      pageId: activePage.id
    };
    let entityType;
    if (activePage.type === 'TRAVEL') {
      entityType = TRAVEL_TYPES[entity.type];
    } else {
      entityType = ENTITY_TYPES[activePage.type];
    }
    return fetch('/web-api/v2/cms/entity/delete',
      {
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(requestBody)
      })
      .then(() => dispatch(entityDeleted(entity.id)))
      .then(() => dispatch(confirmation({ message: `${entityType} Removed` })));
  };
}



// WEBPACK FOOTER //
// ./src/actions/website/EntityActions.js